import {
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  EditButton,
  Filter,
  List,
  SelectField,
  SingleFieldList,
  TextField,
  TextInput,
} from 'react-admin'
import { makeStyles } from 'tss-react/mui'
import { CustomerChipField, LinkToRecord } from '~/components'
import { documentTypeChoices } from '~/types/choices'

const DocumentsFilter = (props) => (
  <Filter {...props}>
    <TextInput label='pos.search' source='type' alwaysOn />
  </Filter>
)

const useStyles = makeStyles()((theme) => ({
  tableCell: {
    maxWidth: 330,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}))

const DocumentList = (props) => {
  const { classes } = useStyles()
  return (
    <List title='resources.documents.title' filters={<DocumentsFilter />} {...props}>
      <Datagrid bulkActionButtons={false} rowClick='edit'>
        {/* <TextField source='type' label='resources.documents.fields.type' /> */}
        <SelectField
          source='type'
          choices={documentTypeChoices}
          label='resources.documents.fields.type'
        />
        <ArrayField source='document_customer'>
          <SingleFieldList linkType={false}>
            <LinkToRecord resource='customers' id='customer_id'>
              <CustomerChipField source='customer' />
            </LinkToRecord>
          </SingleFieldList>
        </ArrayField>
        <ArrayField source='document_boat'>
          <SingleFieldList linkType={false}>
            <LinkToRecord resource='boats' id='boat_id'>
              <ChipField source='boat.model' />
            </LinkToRecord>
          </SingleFieldList>
        </ArrayField>
        <TextField source='history[0].user.display_name' label='history.modified_by' />
        <DateField source='history[0].time' showTime label='history.last_modified' />
        <EditButton />
      </Datagrid>
    </List>
  )
}

export default DocumentList
